import React from 'react';

export default function Footer() {
  return (
    <footer className="py-10 px-4 bg-white border-t mt-0">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2 mb-2 md:mb-0">
          <img src="/azen.ico" alt="ArcAttend logo" className="w-8 h-8 rounded-full object-cover" />
          <span className="font-bold text-lg text-blue-700">ArcZen</span>
        </div>
        <div className="text-gray-400 text-xs">Copyright © 2025 ArcZen. All rights reserved.</div>
      </div>
    </footer>
  );
} 